import { render, staticRenderFns } from "./PermissionMgmt.vue?vue&type=template&id=4a501d78"
import script from "./PermissionMgmt.vue?vue&type=script&lang=js"
export * from "./PermissionMgmt.vue?vue&type=script&lang=js"
import style0 from "./PermissionMgmt.vue?vue&type=style&index=0&id=4a501d78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports